import { render } from "./announcement.vue?vue&type=template&id=5cd155f3&scoped=true"
import script from "./announcement.vue?vue&type=script&lang=js"
export * from "./announcement.vue?vue&type=script&lang=js"

import "./announcement.vue?vue&type=style&index=0&id=5cd155f3&scoped=true&lang=css"

import exportComponent from "D:\\Code\\mt\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd155f3"]])

export default __exports__